<mat-form-field appearance="outline" class="w-100">
  <ngx-spinner
    [zIndex]="-1"
    name="spBusqueda"
    bdColor="rgba(255,255,255,0.8)"
    size="small"
    color="var(--primary-color)"
    type="line-scale"
    [fullScreen]="false"
  ></ngx-spinner>

  <mat-label>
    Casos
  </mat-label>

  <input
    #inputBusqueda
    [disabled]="disable"
    type="search"
    [placeholder]="textoPlaceholder"
    matInput
    [matAutocomplete]="auto"
    [formControl]="entityControl"
    autocomplete="off"
  />

  <mat-icon matPrefix>search</mat-icon>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="null">
    <!-- Mensaje de carga -->
    <mat-option *ngIf="!casosDto" disabled>
      <mat-icon>hourglass_empty</mat-icon>
      <span class="ml-2">Cargando casos...</span>
    </mat-option>

    <!-- Mensaje de caracteres mínimos -->
    <mat-option *ngIf="casosDto && entityControl.value && entityControl.value.length < MIN_CARACTERES" disabled>
      <mat-icon>info</mat-icon>
      <span class="ml-2">Escriba al menos {{ MIN_CARACTERES }} caracteres</span>
    </mat-option>

    <!-- Mensaje sin resultados -->
    <mat-option *ngIf="mostrarSinResultados" disabled>
      <mat-icon>sentiment_dissatisfied</mat-icon>
      <span class="ml-2">{{ mensajeSinResultados }}</span>
    </mat-option>

    <!-- Contador de resultados -->
    <mat-option *ngIf="hayResultados" disabled class="contador-header">
      <mat-icon>info</mat-icon>
      <span class="ml-2"><strong>{{ textoContador }}</strong></span>
    </mat-option>

    <!-- Resultados -->
    <mat-option
      *ngFor="let caso of filteredCaso | async; let i = index; trackBy: trackByItems"
      [value]="caso.descripcion"
      (click)="selectValue(caso)"
      (onSelectionChange)="selectValue(caso)"
      class="resultado-item"
    >{{ caso.descripcion | titlecase }}
    </mat-option>
  </mat-autocomplete>

  <!-- Botones de acción -->
  <div matSuffix class="flex items-center">
    <!-- Botón actualizar -->
    <button
      type="button"
      mat-icon-button
      (click)="actualizarCasos()"
      matTooltip="Actualizar lista"
      matTooltipPosition="below"
      class="mr-1"
    >
      <mat-icon color="primary">refresh</mat-icon>
    </button>

    <!-- Botón nuevo -->
    <button *ngIf="mostrarBotonNuevo"
      type="button"
      mat-icon-button
      (click)="abrirDialogoNuevo($event)"
      matTooltip="Crear nuevo caso"
      matTooltipPosition="below"
      class="mr-1"
    >
      <mat-icon color="primary">add_circle</mat-icon>
    </button>

    <!-- Botón limpiar -->
    <button
      type="button"
      mat-icon-button
      matTooltip="Limpiar selección"
      matTooltipPosition="below"
      *ngIf="entitySelect && entityControl.value"
      (click)="limpiarSeleccion($event)"
    >
      <mat-icon color="warn">clear</mat-icon>
    </button>
  </div>

  <!-- Mensajes de validación -->
  <mat-error *ngIf="entityControl.hasError('minlength')">
    Debe ingresar al menos {{ MIN_CARACTERES }} caracteres
  </mat-error>

</mat-form-field>
